import Big from 'big.js'
import { rateApi } from '../api'

export interface ConvertAmountArgs {
  currencyFrom?: string
  currencyTo?: string
  amount?: string
  username: string
}

export const convert = ({ amount, rate }: { amount?: string | number | null; rate?: string }) => {
  if (!amount || !rate) {
    return null
  }

  return new Big(amount).times(rate).round(2, 3).toNumber()
}

export const getConvertedAmount = async ({ currencyFrom, currencyTo, amount, username }: ConvertAmountArgs) => {
  if (!currencyFrom || !currencyTo || amount == null) {
    return ''
  }

  if (Number(amount) === 0) {
    return '0'
  }

  if (currencyFrom === currencyTo) {
    return amount
  }

  const response = await rateApi.getRate(
    {
      currency_from: currencyFrom,
      currency_to: currencyTo,
      amount_from: amount,
    },
    username
  )

  return response?.data?.amount_to
}

export const convertAmountOnChange = (value: string, args?: Omit<ConvertAmountArgs, 'value'>) => {
  if (!args) {
    return ''
  }

  return getConvertedAmount({ amount: value, ...args })
}
